import React, { useEffect } from 'react';
import useWindowDimensions from 'Components/hooks/useWindowDimensions';
import debounce from 'lodash/debounce';
import LockdownChart from '@reuters-graphics/chart-module-countrylockdownscatterplot';

const lockdownChart = new LockdownChart();

const getChartColors = (activeCategory) => {
  switch (activeCategory) {
    case 'c1':
    case 'c2':
    case 'c6':
      return {
        0: '#4C566A',
        1: '#948072',
        2: '#f68e26',
        3: '#de2d26',
      };
    case 'c8':
      return {
        0: '#4C566A',
        1: '#948072',
        2: '#f68e26',
        3: '#e6550d',
        4: '#d3000e',
      };
  };
};

const getChartData = (series, measureValues, forceFlag = false) => {
  const { flag, values } = measureValues;
  return series.map((date, i) => ({
    date: date.split('T')[0],
    index: values[i],
    flag: forceFlag ? 1 : flag ? flag[i] : null,
  }));
};

const getChartLegend = (activeCategory, content) => {
  switch (activeCategory) {
    case 'c1':
      return {
        0: content.schools['0'],
        1: content.schools['1'],
        2: content.schools['2'],
        3: content.schools['3'],
        4: null,
      };
    case 'c2':
      return {
        0: content.workplace['0'],
        1: content.workplace['1'],
        2: content.workplace['2'],
        3: content.workplace['3'],
        4: null,
      };
    case 'c6':
      return {
        0: content.home['0'],
        1: content.home['1'],
        2: content.home['2'],
        3: content.home['3'],
        4: null,
      };
    case 'c8':
      return {
        0: content.borders['0'],
        1: content.borders['1'],
        2: content.borders['2'],
        3: content.borders['3'],
        4: content.borders['4'],
      };
  }
};

const StripPlot = (props) => {
  const { content, lockdownData, locale, activeCategory } = props;

  const countryKey = Object.keys(lockdownData.countries)[0];
  const { series: lockdownSeries } = lockdownData;
  const lockdownMeasures = lockdownData.countries[countryKey].cIndex;

  const chartData = getChartData(
    lockdownSeries,
    lockdownMeasures[activeCategory],
    activeCategory === 'c8'
  );
  const { width } = useWindowDimensions();
  const stripChartContainer = React.createRef();

  const resize = debounce(() => {
    lockdownChart.draw();
  }, 250);

  useEffect(() => {
    lockdownChart
      .selection(stripChartContainer.current)
      .data(chartData)
      .props({
        locale,
        dateSeries: [
          lockdownSeries[0].split('T')[0],
          lockdownSeries.slice(-1)[0].split('T')[0],
        ],
        dataParams: {
          date: 'date',
          index: 'index',
          stepValue: 'flag',
          steps: 2,
        },
        height: 100,
        stripHeight: 36,
        stripColor: getChartColors(activeCategory),
        chartTitle: content.geo.title,
        dateFormat: locale !== 'ja' ? '%b %e' : '%B %e日',
        legendItems: { // should contain items from stripColor
          null: content.noData,
          stepLegend: {
            0: content.geo.local,
            1: content.geo.nationwide,
          },
          indexLegend: getChartLegend(activeCategory, content),
        },
      })
      .draw();
  }, [content, chartData, locale, lockdownSeries, stripChartContainer, activeCategory]);

  // Resize chart
  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  if (!lockdownData) return null;

  return (
    <div>
      <div className='country-lockdown-strips-chart-container' ref={stripChartContainer} />
    </div>
  );
};

export default StripPlot;
